<script setup lang="ts">
import currentUser from '@@/bits/current_user'
import { __ } from '@@/bits/intl'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from '@@/pinia/window_size'
const windowSizeStore = useWindowSizeStore()
const { isBiggerThanTabletLandscape } = storeToRefs(windowSizeStore)
let prefilledMessage = ''
if (currentUser == null || currentUser.name == null || currentUser.email == null) {
  prefilledMessage = __('User: Unknown\n----\nHi Padlet, ')
} else {
  prefilledMessage = __('User: %{name} - %{email}\n----\nHi Padlet, ', {
    name: currentUser.name || '',
    email: currentUser.email || '',
  })
}
const encodedPrefilledMessage = encodeURIComponent(prefilledMessage)
const subheading = __(
  "Submitting this form will help us respond to your request faster. If you would prefer to send us a quick message, our WhatsApp number is <a href='%{whatsappLink}' target='_blank'>+1-844-472-3538</a>. If <a href='https://padlet.com/' target='_blank' >%{padletPage}</a> is unavailable for you at the moment, please check out <a href='https://status.padlet.help/' target='_blank' >%{statusPage}</a> to see the current status of our site.",
  {
    padletPage: 'padlet.com',
    statusPage: 'status.padlet.help',
    whatsappLink: `https://wa.me/18444723538?text=${encodedPrefilledMessage}`,
  },
)
</script>

<template>
  <div :class="['contact-header', !isBiggerThanTabletLandscape && 'tablet']">
    <div class="contact-header-text">
      <h1>{{ __('Contact Padlet') }}</h1>
      <p v-html="subheading"></p>
    </div>
  </div>
</template>

<style lang="scss">
.contact-header {
  width: 100%;
  padding: 80px 0px;
  box-sizing: border-box;
}
.contact-header-text {
  margin: 0 auto;
  width: 60%;
  height: 100%;
  max-width: 836px;
  min-width: 630px;
  color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--body-text-color);
}

h1 {
  font-size: 50px;
  line-height: 50px;
  margin: 0;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  line-height: 30px;

  a {
    color: var(--link-color);
    text-decoration: none;

    &:hover {
      color: darken(#ff4081, 10%);
    }
  }
}

.contact-header.tablet {
  padding: 60px 0px;

  .contact-header-text {
    box-sizing: border-box;
    min-width: unset;
    padding: 0 14px;
    width: 100%;
  }

  h1 {
    font-size: 40px;
  }
}
</style>
